export const formatNumber = numberString => {
  const string = numberString.toUpperCase();
  let number;
  if (string.includes('M')) {
    number = Number(string.replace('M', '')) * 1000000;
  } else if (string.includes('K')) {
    number = Number(string.replace('K', '')) * 1000;
  }
  return number;
};

export const toPercent = (num) => {
  return (num * 100).toFixed(0);
};
